<script lang="ts">
  import { filtersStore } from "$lib/stores/filters.svelte";
  import { ChevronDown, ChevronUp, Funnel, FunnelX } from "lucide-svelte";
  import Checkbox from "./ui/checkbox/checkbox.svelte";
  import { poiStore } from "$lib/stores/pois.svelte";

  function handleImgError(e: any, icon: string) {
    e.target.onerror = null;
    e.target.src = `/assets/icons/${icon}.svg`;
    e.target.class = "w-14 h-14";
  }

  function getPoiNumberOfCategory(subCategory: string): number {
    return Array.from(poiStore.loadedPois).filter(
      ([_, poiItem]) => poiItem.subCategory === subCategory
    ).length;
  }
</script>

<!-- Header with toggle all button -->
<div class="p-4 mx-2 flex border-b justify-between border-black font-extrabold">
  <h3 class="text-xl text-foreground mb-2">Szűrők</h3>
  <button
    class="bg-ring w-48 text-primary-foreground items-center flex gap-2 hover:bg-ring/90 pl-4 py-1.5 rounded text-xs transition-colors"
    onclick={() => filtersStore.toggleAllFiltersAndSubcategories()}
  >
    {#if filtersStore.everyFilterEnabled}
      <FunnelX size={20} />
      Összes kikapcsolása
    {:else}
      <Funnel size={20} />
      Szűrők törlése
    {/if}
  </button>
</div>

<!-- Categories -->
{#each Object.values(filtersStore.filters) as category (category.id)}
  {@const checked = category.allEnabled}
  <div class="border-b border-border last:border-b-0 px-4 sm:px-8">
    <!-- Category header -->
    <div class="flex items-center gap-4 py-2">
      {#key checked}
        <Checkbox
          {checked}
          class="size-5"
          onclick={() => filtersStore.toggleMainFilter(category.id)}
        />
      {/key}

      <img
        src={`/assets/icons/${category.id.toLowerCase()}.svg`}
        alt="filter icon"
        class="w-20 h-20 flex-shrink-0"
      />

      <button
        class="flex-1 flex justify-between items-center text-muted-foreground hover:text-foreground transition-colors text-xs pl-2"
        onclick={() => (category.open = !category.open)}
      >
        <span class="text-base text-foreground font-extrabold">
          {category.name}
        </span>
        {#if category.open}
          <ChevronUp size={32} class="ml-2" />
        {:else}
          <ChevronDown size={32} class="ml-2" />
        {/if}
      </button>
    </div>

    <!-- Subcategories -->
    {#if category.open}
      <div class="p-3">
        <div class="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {#each Object.values(category.subcategories) as subcategory (subcategory.id)}
            {@const poiNumber = getPoiNumberOfCategory(subcategory.id)}
            <button
              class="flex flex-col border-2 border-black hover:-translate-y-0.5 hover:shadow-[2px_2px_0px_0px] items-center justify-center p-3 rounded-sm transition-all {subcategory.enabled
                ? 'bg-primary font-medium text-foreground hover:bg-primary -translate-y-0.5 shadow-[2px_2px_0px_0px]'
                : 'bg-card hover:bg-primary/50'}"
              onclick={() =>
                filtersStore.toggleSubFilter(category.id, subcategory.id)}
            >
              <span
                class="text-xs font-extrabold text-center text-primary-foreground leading-tight"
              >
                {subcategory.value}
              </span>
              <img
                src={`/assets/icons/${subcategory.id.toLowerCase()}.svg`}
                onerror={(e) => handleImgError(e, category.id.toLowerCase())}
                alt="filter icon"
                class="w-14 h-14"
              />
              <span
                class="text-xs w-full font-sans text-start text-foreground leading-tight"
              >
                {poiNumber} db
              </span>
            </button>
          {/each}
        </div>
      </div>
    {/if}
  </div>
{/each}
